import React from 'react';
import { makeStyles,createStyles } from '@material-ui/core/styles';
import '../../assets/css/main.css';
import theme from '../../styles/theme.js';

const FeesAndChargesNotice = (props) => {
  const classes = useStyles();
  const date = new Date(1769757382000);

return (
    <div>
      <div className='privacy-container'>
        <div className='NavBar-area' />
        <div className='container'>
            <>
              <div className={classes.container}>
                <text className={classes.title}> Aviso De Comisiones Y Cargos </text>
                <p className={classes.subTitle}>
                  Fecha de actualización: {date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                  })}
                </p>
                <iframe
                title="Aviso De Comisiones Y Cargos" 
                src='/documents/feesAndChargesNotice.pdf#toolbar=0' width="100%" height="100vh" style={{height: '100vh'}}/>
              </div>
            </>
        </div>
      </div>
    </div>
  );
};

export default FeesAndChargesNotice;

const rem = 16;

const useStyles = makeStyles({
  defaultText: {
    textAlign: 'left',
    fontFamily: 'Nunito',
    fontWeight: 500,
  },
  container: {
    backgroundColor: theme.palette.white.main,
    width: 'calc(80%)',
    padding: '5%',
    borderRadius: 20,
    marginBottom: '5%',
    marginTop: '2%',
  },
  title: {
    // width: '60%',
      fontSize: 2.25 * rem,
    textAlign: 'center',
    fontWeight: 900,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      textAlign: 'center'
    },
  },
  subTitle: {
    fontSize: 1.25 * rem,
    fontWeight: 700,
    textAlign: 'right',
    marginBottom: '2%',
  },
  link: {
    color: theme.palette.primary.main,
    ':visited': {
      color: 'pink',
    },
  },
});